<template>
  <ContextMenuWrapper v-if="hasAiAddon" placement="bottom-start">
    <ButtonComponent data-testid="ai-addon-settings-trigger" variant="link" icon="general.adjust"></ButtonComponent>
    <template #menu>
      <div v-if="isOrgUserAdmin && isAiAddonTrial">
        <MenuLink icon="general.buy" :href="plansHref" data-testid="viewer-ai-addon-buy">Buy AI add-on now</MenuLink>
        <MenuLink icon="general.minus" v-if="!orgTrial" :href="plansHref" data-testid="viewer-ai-addon-opt-out">Request AI opt-out</MenuLink>
        <MenuSeparator />
      </div>
      <MenuLink icon="general.cog" :href="aiSettingsHref" data-testid="viewer-ai-addon-settings-link">AI Settings</MenuLink>
    </template>
  </ContextMenuWrapper>
</template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { ButtonComponent } from '@/storybook';
import { ContextMenuWrapper, MenuLink, MenuSeparator } from '@/storybook/menu';

import { useUserStore } from '@/store/useUserStore';
import { useAddon } from '@/modules/viewer/composables/useAddon';
import { useOrganizationStore } from '@/store/useOrganizationStore';
import { computed } from 'vue';

const organizationStore = useOrganizationStore();
const userStore = useUserStore();
const { trial: orgTrial, id: organizationId } = storeToRefs(organizationStore);
const { isAiAddonTrial, hasAiAddon } = useAddon();
const { isOrgUserAdmin } = storeToRefs(userStore);

const plansHref = '/account/plans';
const aiSettingsHref = computed(() => {
  const id = organizationId?.value;
  if (!id) return '/account/plans';
  return `/organizations/${id}/account/settings#zightai`;
});
</script>
